import api from './api';
import { PUBLIC_URLS } from '../components/config/apiConfig';

const publicService = {
  // Membership Plans
  getMembershipPlans: async () => {
    const response = await api.get(PUBLIC_URLS.MEMBERSHIP_PLANS);
    return response.data;
  },
  
  // Programs
  getPrograms: async (params) => {
    const response = await api.get(PUBLIC_URLS.PROGRAMS, { params });
    return response.data;
  },
  
  // Resources
  getPublicResources: async (params) => {
    const response = await api.get(PUBLIC_URLS.RESOURCES, { params });
    return response.data;
  },
  
  // Professionals
  getProfessionals: async (params) => {
    const response = await api.get(PUBLIC_URLS.PROFESSIONALS, { params });
    return response.data;
  },
  
  getProfessionalListingPrice: async () => {
    const response = await api.get(PUBLIC_URLS.PROFESSIONAL_LISTING_PRICE);
    return response.data;
  },
  
  checkProfessionalListingEligibility: async () => {
    try {
      const response = await api.get(PUBLIC_URLS.PROFESSIONAL_LISTING_ELIGIBILITY);
      return response.data;
    } catch (error) {
      console.error('Error checking professional listing eligibility:', error);
      // Add more context to the error
      if (error.response && error.response.data) {
        error.additionalInfo = error.response.data;
      }
      throw error;
    }
  },
  
  submitProfessionalListing: async (listingData) => {
    const response = await api.post(PUBLIC_URLS.PROFESSIONAL_LISTINGS, listingData);
    return response.data;
  },
  
  createNonMemberProfessionalListing: async (listingData) => {
    const response = await api.post(PUBLIC_URLS.PROFESSIONAL_LISTINGS_NON_MEMBER || PUBLIC_URLS.PROFESSIONAL_LISTINGS, listingData);
    return response.data;
  },
  
  getMemberProfile: async () => {
    const token = localStorage.getItem('memberToken') || sessionStorage.getItem('memberToken');
    if (!token) {
      return Promise.reject(new Error('No authentication token'));
    }
    
    const response = await api.get(PUBLIC_URLS.MEMBER_PROFILE, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  },
  
  // Gallery
  getGallery: async (params) => {
    const response = await api.get(PUBLIC_URLS.GALLERY, { params });
    return response.data;
  },
  
  // Contact
  submitContactForm: async (formData) => {
    const response = await api.post(PUBLIC_URLS.CONTACT, formData);
    return response.data;
  }
};

export default publicService;
